import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { generateDataTestId } from 'src/utils';
import { Room as RoomType } from '../edit/control/LevelsAndRooms/types';

interface AddResourceButtonProps {
  label: string;
  value: number;
  onIncrement: () => void;
  disabled?: boolean;
  dataProps?: RoomType | string | undefined;
}

/**
 * Field with increment button
 */
const AddResourceButton: React.FC<AddResourceButtonProps> = ({
  label,
  value,
  onIncrement,
  disabled = false,
  dataProps,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mr: 3,
      }}
    >
      <IconButton
        data-testid={generateDataTestId(
          `${dataProps}`,
          undefined,
          `${label}-incrementButton`,
        )}
        size="small"
        onClick={onIncrement}
        disabled={disabled}
        sx={{
          p: 0,
          color: disabled ? 'grey.400' : 'info.dark',
          border: '1.5px solid',
          borderColor: disabled ? 'grey.400' : 'info.dark',
          '&:hover': {
            backgroundColor: disabled ? 'transparent' : 'info.dark',
            color: disabled ? 'grey.400' : 'info.contrastText',
          },
        }}
      >
        <AddIcon fontSize="small" sx={{ fontSize: 12, fontWeight: 'bold' }} />
      </IconButton>

      <Typography
        component="span"
        variant="body2"
        sx={{
          fontWeight: 'bold',
          ml: 1,
          mr: 0.5,
        }}
      >
        {value}
      </Typography>

      <Typography
        component="span"
        variant="body2"
        sx={{
          fontWeight: 'bold',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default AddResourceButton;
